<template>
  <div
    class="refiner-skeleton"
    data-testid="workspace-document-refiner-skeleton"
  >
    <PVSkeleton width="7rem" height="1rem" />
    <div
      v-for="optionIndex in optionCount"
      :key="optionIndex"
      class="refiner-skeleton__option"
    >
      <PVSkeleton shape="circle" size="1.125rem" />
      <PVSkeleton width="100%" height="0.875rem" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import PVSkeleton from 'primevue/skeleton';

  const optionCount = 4;
</script>

<style scoped lang="scss">
  .refiner-skeleton {
    display: flex;
    flex-direction: column;
    row-gap: 0.75rem;

    &__option {
      display: flex;
      align-items: center;
      column-gap: 0.5rem;
    }
  }
</style>
